import { useMutation } from "@tanstack/react-query";
import useGroupAPIClient from "./useGroupAPIClient";
import { CreateGroupVariables, UpdateGroupVariables } from "../types";

export const useCreateGroup = () => {
    const { postGroup } = useGroupAPIClient();
    return useMutation((group: CreateGroupVariables) => postGroup(group));
};

export const useUpdateGroup = () => {
    const { updateGroup } = useGroupAPIClient();

    return useMutation((group: UpdateGroupVariables) => updateGroup(group));
};
